





































import {Vue, Component, Watch} from 'vue-property-decorator';
import {FeathersVuexFindAll} from '@/utils';
import {IMAGE_POSITION, multiNil, nil, UPLOAD_PURPOSES} from '@/common';
import keyedImageDefault from '@/instance-defaults/keyedImageDefault';
import ImportDialog from '@/components/Views/Dashboard/Import & Export/ImportDialog.vue';
import SelectImportedFilesDialog from '@/components/Views/Dashboard/Import & Export/SelectImportedFilesDialog.vue';
import {pickBy} from 'lodash';
import ImageTile from '@/components/Views/UI/ImageTile.vue';
import ImagePositionSelector from '@/components/Views/UI/ImagePositionSelector.vue';

@Component({
    components: {
        ImagePositionSelector,
        ImageTile,
        SelectImportedFilesDialog,
        ImportDialog,
    },
})
export default class DashboardImages extends Vue {
    public selectedImage = null;
    public activeKeyedImage = keyedImageDefault;
    public keys: any[] = [];
    public purpose = UPLOAD_PURPOSES.IMAGE_SITE;
    public mounted() {
        this.getImageKeys();
    }
    public async getImageKeys() {
        const {KeyedImage} = this.$FeathersVuex;
        this.keys = await FeathersVuexFindAll(KeyedImage, {});
    }
    public selectedKeyedImage(keyedImage) {
        this.activeKeyedImage = keyedImage;
    }
    public get currentImage() {
        if (multiNil(this, 'activeKeyedImage.image')) { return ''; }
        return this.activeKeyedImage.imageModel.file;
    }
    public onImageImported(image) {
        this.activeKeyedImage.image = image._id;
        this.activeKeyedImage.save();
        (this.$refs.importImage as any).open = false;
    }
    @Watch('activeKeyedImage.imagePosition')
    public onActiveKeyedImageImagePositionChanged(value: string, oldValue: string) {
        this.activeKeyedImage.save();
    }
    public set asSelectionMap(value) {
        this.activeKeyedImage.image = Object.keys(pickBy(value, (x) => x))[0];
        this.activeKeyedImage.save();
    }
    public get asSelectionMap() {
        // return {this.this.activeKeyedImage}
        if (nil(this.activeKeyedImage.image)) {
            return {};
        } else {
            const obj = {};
            obj[this.activeKeyedImage.image] = true;
            return obj;
        }
    }
}
